<style>
  footer {
    clear: both;
    font-size: 0.8em;
    text-align: center;
  }
  footer p {
    margin: 1em;
  }
</style>

<footer>
  <p class="disclaimer">
    Addresses and postcodes are approximate.
    Blue circle is the result.
    In case of reverse geocoding the smaller red circle is at the search position.
  </p>
  <p class="copyright">
    &copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors
  </p>
</footer>
